<template>
  <v-app class="manage-new-group">
    <Header />
    <div class="container">
      <div class="user-wrapper">
        <div class="d-flex justify-space-between pt-5 pb-5 align-items-center">
          <span class="font-weight-bold black--text title">
            Edit User Group
          </span>
          <span class="font-weight-bold black--text backto-usergroup">
            <v-btn
              style="color: #000"
              :ripple="false"
              plain
              @click="newUser"
              elevation="0"
              class="back-user-btn text-inherit"
            >
              <v-icon aria-hidden="false" class="mr-2" style="color: #000">
                mdi-arrow-left </v-icon
              >Back to User Groups</v-btn
            >
          </span>
        </div>
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="mb-3">
            <v-col cols="5" class="pa-0">
              <v-text-field
                class="channel-name"
                label="User Group Name*"
                v-model="editGroup.name"
                :rules="nameRules"
                @change="change"
                required
              ></v-text-field>
            </v-col>
          </div>
          <div class="toggle-switch mb-3 d-flex">
            <div class="mr-16">
            <label for="Status" class="custom-label">Status</label>
            <v-switch
              class="mt-2"
              v-model="editGroup.status"
              :label="editGroup.status ? 'Active' : 'Inactive'"
              :ripple="false"
              @change="change"
            ></v-switch>
            </div>
            <div class="toggle-switch">
              <label for="Shortcut" class="custom-label">Shortcut</label>
            <v-switch
              class="mt-2"
              v-model="editGroup.shortcut"
              :label="editGroup.shortcut ? 'Yes' : 'No'"
              :ripple="false"
              @change="change"
              :class="[
                editGroup.status === false
                  ? 'btn-disabled'
                  : ''
              ]"
            ></v-switch>
            </div>
          </div>
          <div>
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0 email-autobox mb-3">
                  <v-combobox
                    ref="el"
                    class="remove-email"
                    v-model="receiverEmail"
                    append-icon
                    chips
                    deletable-chips
                    label="Add Email(s)*"
                    :delimiters="[',', ';']"
                    multiple
                    required
                    :rules="emailRules"
                    :search-input.sync="emailsearch"
                    @update:search-input="updateReceiverEmails"
                    @change="change"
                    :hide-no-data="!emailsearch"
                    :items="people"
                    hide-selected
                    :menu-props="{ closeOnContentClick: true }"
                    @keydown="EditGrouphandleInput($event)"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-icon
                          aria-hidden="false"
                          class="mr-2 user-icon"
                          dark
                          style="color: #fff"
                          >mdi-account</v-icon
                        >
                        <v-list-item-title
                          style="color: #000"
                          v-html="data.item"
                        ></v-list-item-title>
                      </template>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="12" class="pa-0 d-flex justify-end">
                  <v-btn
                    tile
                    outlined
                    :ripple="false"
                    border="solid"
                    height="40"
                    elavation="0"
                    min-width="100px"
                    class="mr-5 text-capitalize black--text font-weight-bold"
                    @click="reseteditGroup"
                    :disabled="isDisabled"
                    >Reset
                  </v-btn>
                  <v-btn
                    class="btn-solid text-capitalize"
                    tile
                    color="#3a83c3"
                    dark
                    height="40"
                    min-width="100px"
                    :ripple="false"
                    elavation="0"
                    @click="saveGroup"
                    :class="[
                      isDisabled ? 'save-newuser-disabled' : 'save-newuser'
                    ]"
                  >
                    Save</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-form>
      </div>
    </div>
  </v-app>
</template>

<script>
import { bus } from "../../main";
import Header from "../Header/HeaderPage";
export default {
  name: "EditUserGroup",
  props: {
    msg: String
  },
  components: {
    Header
  },
  data() {
    return {
      switch1: true,
      autoUpdate: true,
      receiverEmail: [],
      emailsearch: "",
      emails: "",
      isDisabled: true,
      isUpdating: false,
      valid: true,
      people: [],
      editGroup: {
        name: "",
        receivers: [],
        status: true,
        id: "",
        created_by: "",
        usergroup: 1,
        shortcut:true
      },
      resetdata: {},
      selectedIndex: {
        usergroup: ""
      },
      editqueryparam: {
        usergroup: ""
      },
      nameRules: [
        v => {
          if (!v || v.length < 1) return "Group Name is required";
          else if (v.length > 0) {
            let invalidNames = [];
            let name = v;
            if (
              !new RegExp(
                /^([^<>()\[\]\\.,;:\s"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|([a-zA-Z0-9])|([a-zA-Z0-9])$/
              ).test(name)
            ) {
              invalidNames.push(name);
            } else if(new RegExp(
                   /^(([^<>()\[\]\\.,;:@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
                ).test(name)){
               return "Email address can not be used as User Group name."
            }
            if (invalidNames.length) {
              return `Invalid Group Name(s) - ${invalidNames}`;
            }
          }
          else return v;
        }
      ],
      emailRules: [
        r => {
          if (!r || r.length < 1) return "Email is required";
          else if (r.length > 0) {
            let invalidEmails = [];
            for (let i = 0; i < r.length; i++) {
              let email = r[i];
              if (
                !new RegExp(
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                ).test(email)
              ) {
                invalidEmails.push(email);
              }
            }
            if (invalidEmails.length) {
              return `Invalid email(s) - ${invalidEmails.join(",")}`;
            }
            return r;
          }
          else return r;
        }
      ]
    };
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    }
  },
  created() {
    bus.$on("clicked-on-edit", data => {
      this.editGroup = data
      this.receiverEmail = this.editGroup.receivers
      // this.editGroup.status = data['status']
      // this.editGroup.shortcut = data['shortcut']
      // this.receiverEmail = ["ambika@gmail.com"]
      this.resetdata = data
    });
  },
  methods: {
    change(event) {
      this.people = [];
      this.emailsearch = ''
      if (event.length <= 0) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if(this.editGroup.status === "Inactive" || this.editGroup.status === false){
        this.editGroup.shortcut = "No"
        this.editGroup.shortcut = false
      } 
    },
    EditGrouphandleInput(e){
      if (e.key === "Backspace" || e.key === "Delete") {
        this.people = [];
      }
    },
    newUser() {
      this.$router.replace({ path: "/user-group" });
      this.$forceUpdate();
    },
    updateReceiverEmails(e1) {
      const currentReceiver = this.editGroup.receivers.length;
      let inputEmails = this.emailsearch;
      if (
        inputEmails.length === 0 &&
        currentReceiver === this.receiverEmail.length
      ) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if (this.emailsearch && this.emailsearch.split(";").length > 1) {
        this.receiverEmail = this.receiverEmail.concat(
          this.emailsearch
            .split(";")
            .filter(term => !this.receiverEmail.includes(term.trim()))
        );
        this.receiverEmail.forEach((x, i) => {
          this.receiverEmail[i] = x.trim();
        });
        this.emailsearch = "";
      }
      /*---------------------------for Autosuggest API call--------------------------------*/
      if (this.emailsearch.length >= 3) {
        const vm = this;
        const domainUrl = "api/emailsearch/";
        let queryParam = { email_id: this.emailsearch };
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, queryParam)
          .then(data => {
            let searchResults = data.data;
            searchResults.forEach(ele => {
              this.people.push(ele.email_id);
            });
          });
      } else {
        this.people = [];
      }
      this.$refs.el.lazySearch = "";
    },
    saveGroup() {
      //push each reciever email
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.isDisabled = true;
        this.$refs.form.validate();
        this.editGroup.receivers = [];
        const newusergroupUrl = "api/usergroupedit/";
        this.$apiService
          .getData("put", `${newusergroupUrl}`, {}, this.editGroup, null, {})
          .then(data => {
            if (data.data.message) {
              this.$swal({
                icon: "success",
                confirmButtonText: "Ok",
                showCloseButton: true,
                text: data.data.message
              }).then(result => {
                if (result.isConfirmed === true) {
                  console.log(data.data);
                }
              });
            } else{
                this.$swal({
                  icon: "warning",
                  confirmButtonText: "Ok",
                  showCloseButton: true,
                  text: data.data.error
                }).then(result => {
                  cosole.log(data.data.error);
                });
              }
          });

        this.receiverEmail.forEach((ele, index) => {
          this.editGroup.receivers.push(ele);
        });
      }
    },
    reseteditGroup() {
      this.isDisabled = true;
      this.emailsearch = "";
      this.$refs.form.resetValidation();
      this.receiverEmail = this.editGroup.receivers;
      //for reset after edit changes
      this.editqueryparam.usergroup = this.resetdata.id;
      const domainUrl = "api/usergroupedit/";
      let vm = this;
      vm.$apiService
        .getData("get", `${domainUrl}`, {}, {}, null, this.editqueryparam)
        .then(data => {
          this.editGroup.name = data.data.name;
          this.editGroup.status = data.data.status;
        });
    }
  }
};
</script>
<style lang="scss">
@import "../NewUserGroup/NewUserGroup.scss";
</style>
